export { SORT_TYPES } from './sortTypes';

export const DICE_SYNC_COLUMNS = [
  { id: 'event_date', label: 'Show Date', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'event_name', label: 'Event', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'dice_venue_name', label: 'DICE Venue', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'venue_name', label: 'Opendate Venue', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'text' },
  { id: 'dice_state', label: 'DICE State', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'status', label: 'Status', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'tickets_sold', label: 'Tickets Sold', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'ticket_gross', label: 'Ticket Gross', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'tickets_synced_at', label: 'Tickets Synced', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
];

export const getDefaultVisibleColumns = () =>
  DICE_SYNC_COLUMNS.filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  DICE_SYNC_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
